import PropTypes from 'prop-types';

import { forwardRef } from 'react';

import { NavLink as NavLinkBase } from 'react-router-dom'; 

export const NavLink = forwardRef(({ selected, ...props }, ref) => (
  <NavLinkBase
    ref={ref}
    {...props}
    selected={selected}
  />
));

NavLink.displayName = 'NavLink';

NavLink.propTypes = {
  selected: PropTypes.bool
}